import React, { useState } from "react";
import { encryptText, decryptText } from "../../api/encryptionService";

export default function EncryptionPage() {
    const [mode, setMode] = useState("encrypt");
    const [input, setInput] = useState("");
    const [result, setResult] = useState("");
    const [error, setError] = useState("");

    const handleRun = async () => {
        try {
            setError("");
            setResult("");

            const data =
                mode === "encrypt"
                    ? await encryptText(input)
                    : await decryptText(input);

            setResult(data);
        } catch {
            setError("Encryption operation failed.");
        }
    };

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white rounded shadow">
            <h1 className="text-xl font-bold mb-4">Encryption Tool</h1>

            <select
                value={mode}
                onChange={(e) => setMode(e.target.value)}
                className="border p-2 rounded mb-4"
            >
                <option value="encrypt">Encrypt</option>
                <option value="decrypt">Decrypt</option>
            </select>

            <textarea
                className="w-full border p-3 rounded mb-4"
                rows="5"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Enter text"
            />

            <button
                onClick={handleRun}
                className="bg-blue-600 text-white px-4 py-2 rounded"
            >
                Run
            </button>

            {error && <p className="text-red-600 mt-4">{error}</p>}

            {result && (
                <div className="mt-4 p-3 bg-gray-100 rounded break-all">
                    <b>Result:</b>
                    <p>{result}</p>
                </div>
            )}
        </div>
    );
}